import { Form, Input } from "semantic-ui-react";
import { SharedAddressFieldProps } from "./AddressFormField";
import classNames from "classnames";
import { useId } from "react-aria";

interface ZipFormFieldProps extends SharedAddressFieldProps {
  subLabelPadding?: boolean;
}

export function ZipFormField({
  required,
  disabled,
  error,
  labelClassName,
  label = "Zip",
  subLabel,
  value,
  transform,
  handleChange,
  subLabelPadding,
  isMobileLayout,
}: ZipFormFieldProps) {
  const id = useId();
  return (
    <Form.Field
      className={classNames("tw-w-auto tw-text-nowrap", {
        "tw-mb-4": isMobileLayout,
      })}
      required={required}
      disabled={disabled}
      error={!!error}
    >
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      {(subLabel || subLabelPadding) && (
        <div
          className={classNames("sub-label", {
            "tw-text-[#b2b2b2]": disabled,
          })}
        >
          {subLabel}
        </div>
      )}
      <Input
        id={id}
        type='text'
        value={transform.input(value)?.zip ?? ""}
        onChange={(_, { value }) => handleChange({ zip: value })}
        disabled={disabled}
        autoComplete='postal-code'
      />
    </Form.Field>
  );
}
